module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/6bad8d2cf8533163b78c1312122e65e8.png";